var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_15780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.52V3.98C2 2.57 2.64 2 4.23 2H8.27C9.86 2 10.5 2.57 10.5 3.98V8.51C10.5 9.93 9.86 10.49 8.27 10.49H4.23C2.64 10.5 2 9.93 2 8.52Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 19.77V15.73C2 14.14 2.64 13.5 4.23 13.5H8.27C9.86 13.5 10.5 14.14 10.5 15.73V19.77C10.5 21.36 9.86 22 8.27 22H4.23C2.64 22 2 21.36 2 19.77Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.52V3.98C13.5 2.57 14.14 2 15.73 2H19.77C21.36 2 22 2.57 22 3.98V8.51C22 9.93 21.36 10.49 19.77 10.49H15.73C14.14 10.5 13.5 9.93 13.5 8.52Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.5 19.77V15.73C13.5 14.14 14.14 13.5 15.73 13.5H19.77C21.36 13.5 22 14.14 22 15.73V19.77C22 21.36 21.36 22 19.77 22H15.73C14.14 22 13.5 21.36 13.5 19.77Z",
    fill: "#97A1C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_15780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard 2.b0509a2cce21513d963142982ba6434d.svg";
export { ForwardRef as ReactComponent };